import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';


import { WebsiteService } from '../../../services/website/website.services';


@Component({
    selector: 'app-web-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WebContactComponent implements OnInit {


  showSpinner = false;
  webpage: any;

  constructor(
    private webService: WebsiteService,
    ) {
    }

  ngOnInit() {
   
  }

  
}
